import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import React, { useContext, useEffect, useRef, useState } from "react";
import { delimitationService } from "../../services/DelimitationService";
import { reportService } from "../../services/ReportService";
import Viewer, { Worker, defaultLayout } from "@phuocng/react-pdf-viewer";
import "@phuocng/react-pdf-viewer/cjs/react-pdf-viewer.css";
import { Dialog } from "primereact/dialog";
import ReportFilter from "./ReportFilter";
import { AppDB } from "../../App";
import { Accordion, AccordionTab } from 'primereact/accordion';
import { helper } from "../../componets/utils/helper";
import registerManagementReportService from "../../services/RegisterManagementReportService";

export const Reports = ({isPortal=false, reportType ="application"}) => {
	var [reportName, setReportName] = useState("")
	var [loading, setLoading] = useState(false)
	var [activeIndex, setActiveIndex] = useState(0)

	var { toast } = useContext(AppDB)

	const [showDialog, setShowDialog] = useState(false);








	const [bytePdf, setBytePdf] = useState(null);
	function SubmitFilter(report_data) {
		setLoading(true)
		if(report_data?.voterRegisterID)
		{
			var payload = {
				"mergeFiles": true,
				"demarcationList": [
					{
						"DelimitationLevelID": report_data?.delimitationLevelID,
						"DelimitationID": report_data?.delimitationID,
						"voterRegisterID": report_data?.voterRegisterID
					}
				],
				"voterRegisterID": report_data?.voterRegisterID
			};
			registerManagementReportService
			.viewdownloadDelimitationReport(payload)
			.then((res) => {
				if (res?.success === true) {
					var data = helper.base64ToFileUrl(res.data)
					setBytePdf(data)
					setShowDialog(true);
					setActiveIndex(1)
					toast.show({ severity: "success", summary: "Success", detail: "Report Loaded", life: 5000 });
				} else {
					setActiveIndex(0)
					toast.show({ severity: "error", summary: "", detail: "No Data Found", life: 3000 });
				}
					setLoading(false)
			})
			.catch((err) => {
				setLoading(false);
				return toast.show({ severity: "error", summary: "Message", detail: "Something went wrong.", life: 3000 });
			});
		}
		else 
		{
			reportService
				.getReport(report_data)
				.then((res) => {
					if (res?.success === true) {
						var data = helper.base64ToFileUrl(res.data)
						setBytePdf(data)
						setShowDialog(true);
						setActiveIndex(1)
						toast.show({ severity: "success", summary: "Success", detail: "Report Loaded", life: 5000 });
					} else {
						setActiveIndex(0)
						toast.show({ severity: "error", summary: "", detail: "No Data Found", life: 3000 });
					}
					setLoading(false)
				});
		}
	}




	return (
		<div className="grid">
			<div className="col-12">
				<Dialog
					draggable={false}
					maximizable={false}
					maximized
					showHeader={false}
					header={
						<b>
							<h5>{reportName} Report</h5>
						</b>
					}
					style={{ width: "75%", height: "75%" }}
					modal
					visible={showDialog}
					onHide={(e) => {
						setShowDialog(false);
					}}
					footer={
						<>
							<Button className="my-2  p-button-danger" label="Close" onClick={() => { setShowDialog(false) }} icon="pi pi-times" />
						</>
					}
				>

					<div style={{ marginTop: 10 }} className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
						<b >
							<h5 >{reportName} Report</h5>
						</b>
					</div>

					<Worker workerUrl="script/pdf.worker.min.js">
						<Viewer zoomInButton={true} defaultScale={1} onDocumentLoad={console.log} fileUrl={bytePdf} />

					</Worker>

				</Dialog>

				<div className="card">
					<div className="grid">
						<div className="col-12">
							<h3>{isPortal?"Voter's Register":`${reportType?.Name}`}</h3>
							
						</div>
						<div className="col-12">
							<ReportFilter reportType={reportType} isPortal={isPortal} loading={loading} onSubmit={(data, name) => {
								setReportName(name)
								SubmitFilter(data)
							}} />
						</div>

						{/* <div className="col-12">
							<Accordion activeIndex={activeIndex}>
								<AccordionTab header="Header I">
									<div className="col-12">
										<ReportFilter loading={loading} onSubmit={(data, name) => {
											setReportName(name)
											SubmitFilter(data)
										}} />
									</div>
								</AccordionTab>
								<AccordionTab header="Header II">
									<Worker workerUrl="https://unpkg.com/pdfjs-dist@2.13.216/build/pdf.worker.min.js">
										{bytePdf !== null && <Viewer zoomInButton={true} defaultScale={1} onDocumentLoad={console.log} fileUrl={bytePdf} />}

									</Worker>
								</AccordionTab>
							</Accordion>

						</div> */}


					</div>
				</div>
			</div>
		</div>
	);
};
